export interface Profile {
  email: string;
  firstName: string;
  lastName: string;
  photoUrl: string;
  profileId?: string;
  userId?: number;
}

export interface Account {
  userId?: number;
  username: string;
  password?: string;
  domain: string;
  groups: string[];
}

export interface UserContext {
  account: Account;
  profile: Profile;
}

export interface UserInfo {
  userId: number;
  username: string;
  name: string;
  firstSurname: string;
  secondSurname: string;
  email: string;
  employeeNumber: number;
  ldapDn: string;
  groups: string[];
  domain: string;
  latestCredentialChange: string;
  status: string;
  latestLoginDate: string;
  verificationDate: string;
  passwordExpirationDate: string;
  createdDate: string;
  positions: Array<{ positionId: number; name: string }>;
  roles: Array<{ id: number; code: string; description: string }>;
  clubs: Array<any>;
  clubSessionName?: string;
}

export interface SSP {
  ssp: Array<object>;
}

export enum WHO_AM_I_STATE {
  SUCCESS,
  FAILED,
  PROGRESS,
  EMPTY
}
